// Regras de senha alinhadas ao Amazon Cognito.
// Caracteres especiais aceitos pelo Cognito:
// ^ $ * . [ ] { } ( ) ? - " ! @ # % & / \ , > < ' : ; | _ ~ ` + =

// Sub-regras usadas pela checklist de requisitos (uma regex por requisito).
export const PASSWORD_RULES_REGEX = {
  lowercase: /^(?=.*[a-z])/,
  uppercase: /^(?=.*[A-Z])/,
  number: /^(?=.*[0-9])/,
  minAmount: /(?=.{8,})/,
  specialCharacter: /^(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`+=-])/,
};

// Regra completa: mínimo 8 caracteres, com minúscula, maiúscula, número e
// caractere especial. Deve permanecer equivalente às sub-regras acima.
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`+=-])(?=.{8,})/;
